import select from "lib/select";

const strSort = (a, b) => {
    let A = a.toUpperCase(),
        B = b.toUpperCase();
    if (A < B) {
        return -1;
    } else if (A > B) {
        return 1;
    } else {
        return 0;
    }
};

const defaultFilter = val => val !== undefined;
const defaultMap = val => val;

export function filter(object, filter = defaultFilter) {
    return Object.keys(object).reduce(function(res, key) {
        if (filter(object[key], key)) {
            res[key] = object[key];
        }
        return res;
    }, {});
}

const SKIP = {};

export function map(object, map = defaultMap) {
    return Object.keys(object).reduce(function(res, key) {
        let val =  map(object[key], key);

        if (val !== SKIP){
            res[key] = val;
        }

        return res;
    }, {});
}

export default class Mappable {
    constructor(obj) {
        this._obj = obj instanceof Mappable? obj.toObject(): obj || {};
    }

    map(fn) {
        return new Mappable(map(this._obj, fn));
    }

    merge(obj2) {
        obj2 = obj2 instanceof Mappable? obj2.toObject(): obj2;

        if (!obj2 || Object.keys(obj2).length == 0) {
            return this;
        }

        return new Mappable(map(Object.assign({}, obj2, this._obj), (val, key) => {
            if (!obj2.hasOwnProperty(key)) {
                return val;
            }

            if (obj2[key] === void 0) {
                return SKIP;
            }else if (typeof val == "object" && !Array.isArray(val)) {
                return new Mappable(val)
                    .merge(obj2[key])
                    .toObject();
            } else {
                return obj2[key];
            }
        }));
    }

    filter(fn) {
        return new Mappable(filter(this._obj, fn));
    }

    entries() {
        return Object.entries(this._obj);
    }

    values(sort) {
        return Object.keys(this._obj)
            .sort(sort || strSort)
            .map(key => this._obj[key]);
    }

    select(path){
        return select(this._obj, path);
    }

    [Symbol.iterator]() {
        return Object.entries(this._obj)[Symbol.iterator]();
    }

    toObject() {
        return this._obj;
    }

    count(){
        return Object.keys(this._obj).length;
    }
}


// WEBPACK FOOTER //
// ./src/lib/Mappable.js